<template>
  <dl class="jackpot_area">
    <dt class="total">
      <a href="/event/roulette.php" onclick="gaEventer('메인 - 잭팟', '룰렛')">
        <span v-if="!updateGold.total" class="roller">{{ numberWithComma(defaultGold.total.toString()) }}</span>
        <Roller v-show="updateGold.total" :transition="1" :text="updateGold.total || defaultGold.total" :isNumberFormat="true"/>
        <em class="bg"></em>
      </a>
    </dt>
    <dd>
      <span class="tit mega">Mega</span>
      <span class="gold">
        <em>
          <span v-if="!updateGold.mega">{{ numberWithComma(defaultGold.mega.toString()) }}</span>
          <Roller v-show="updateGold.mega" :transition="1" :text="updateGold.mega || defaultGold.mega" :isNumberFormat="true" />
        </em> Gold
      </span>
    </dd>
    <dd>
      <span class="tit major">Major</span>
      <span class="gold">
        <em>
          <span v-if="!updateGold.major">{{ numberWithComma(defaultGold.major.toString()) }}</span>
          <Roller v-show="updateGold.major" :transition="1" :text="updateGold.major || defaultGold.major" :isNumberFormat="true" />
        </em> Gold
      </span>
    </dd>
    <dd>
      <span class="tit minor">Minor</span>
      <span class="gold">
        <em>
          <span v-if="!updateGold.minor">{{ numberWithComma(defaultGold.minor.toString()) }}</span>
          <Roller v-show="updateGold.minor" :transition="1" :text="updateGold.minor || defaultGold.minor" :isNumberFormat="true" />
        </em> Gold
      </span>
    </dd>
    <dd>
      <span class="tit mini">Mini</span>
      <span class="gold">
        <em>
          <span v-if="!updateGold.mini">{{ numberWithComma(defaultGold.mini.toString()) }}</span>
          <Roller v-show="updateGold.mini" :transition="1" :text="updateGold.mini || defaultGold.mini" :isNumberFormat="true" />
        </em> Gold
      </span>
    </dd>
  </dl>
</template>

<script>
  import jackpotRollingMixins from '../../mixins/jackpot-rolling'

  export default {
    name: "jackpot",
    mixins: [jackpotRollingMixins],
    mounted() {
      window.getJackpot =  setInterval(async () => {
        try {
          const { data } = await this.$http.get('/v1/main')
          this.$eventBus.$emit('validMatch', data.liveTriggerGameId)
          this.nameArr.forEach((name) => {
            if (this.updateGold[name] < data.jackpot[name]) {
              this.updateGold[name] += Math.floor(Math.random() * (10 - 1) + 1)
            } else {
              this.updateGold[name] = data.jackpot[name]
            }
          })
        } catch (e) {
          console.log('jackpot fetch Gold error2', e)
        }
      }, 20000)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/main/jackpot.vue